import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { DataGrid , GridToolbar} from '@mui/x-data-grid';
import { API_URL } from '../constants';
import { Select , MenuItem, FormControl,InputLabel} from '@mui/material';
import { Button } from 'react-bootstrap';
import { useSnackbar } from 'notistack';

export default function ExamsList() {
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  //state variables for objects
  const [users, setUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState('');
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
   const user = useSelector(state => state.user.user);

  function getUsers(){
    axios.get(`${API_URL}/certusers`).then(res => {
        setUsers(res.data);
    })
  }

  function getCourses(){
    axios.get(`${API_URL}/getcourses`).then(res => {
        setCourses(res.data);
    })
  }

  const handleChange = (event) => {
    setSelectedCourse(event.target.value);
  }

  const handleRefresh = async(e) => {
    //getUsers();
    setRowSelectionModel([]);
    setSelectedCourse('');
  }

  useEffect(() => {
    console.log('User: ',user);
      if (user.IsAdmin || user.IsVendorAdmin) {
            //good
            getUsers();
            getCourses();
      }
      else{
            navigate('/login');
      }
  }, []);

  const handleSubmit = (e) => {
    console.log(rowSelectionModel, selectedCourse, "Selected Users and Course:");
    let reqBody = {
      codes: rowSelectionModel,
      course: selectedCourse
    }
    axios.post(`${API_URL}/addmultiplecodes`, { reqBody }).then((response) => {
      console.log('Response.data obj:' , response.data);
  }).catch((ex) => {
    console.log('Error occurred in Post: ', ex);
  }).finally((f) => {
    //toast notification 
    enqueueSnackbar('Exam codes assigned and emails have been sent.', { variant: 'success'});
    handleRefresh();
  })
  }

  const columns = [
    { field: 'CertUserID', headerName: 'ID', width:100},
    { field: 'FirstName', headerName: 'First Name', width: 150 },
    { field: 'LastName', headerName: 'Last Name', width: 150 },
    { field: 'Email', headerName: 'Email', width: 150 },
  ];

  //onRowClick={(rows)=> {navigate(`/exam-question-list`, state: {rows.ExamID}) }}

  return (
    <div
      className='container'
      style={{ paddingTop: 125, paddingRight: 200, paddingLeft: 200, height:600, width: 800 }}
    >
      <div className='btn'>
        <Button className='primary' onClick={handleSubmit}>Generate Codes</Button>
      </div>
        <div className='Select'>
        <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Course</InputLabel>
            <Select className='input select' onChange={handleChange}>
                {
                    courses.map((course, index) => (
                        <MenuItem key={index} value={course.CourseID}>{course.CourseName}</MenuItem>
                    ))
                }
                
            </Select>
        </FormControl>
        </div>
      <DataGrid rows={users} columns={columns} 
      getRowId={row => row.CertUserID} 
      checkboxSelection disableRowSelectionOnClick
      slots={{
        toolbar: GridToolbar,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
      }}
      onRowSelectionModelChange={(newRowSelectionModel) => {
        console.log('Row Selection: ',newRowSelectionModel)
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      {...users}
      />
    </div>
  );
}
